import { render, staticRenderFns } from "./order-purchase.vue?vue&type=template&id=0baf3e27&"
import script from "./order-purchase.vue?vue&type=script&lang=js&"
export * from "./order-purchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports